import { render, staticRenderFns } from "./InformationAssetWidgetComponent.vue?vue&type=template&id=2bb608fa&"
import script from "./InformationAssetWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./InformationAssetWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports